import { cancelAllOrders, cancelOrder } from '#/api/apiExchange';
import { makeEthersErrorHumanRedable } from '#/lib/ethereum/ethersErrors';
import { signTypedDataWithModal } from '#/lib/ethereum/sign/signHashWithModal';
import { DelegatedKeyAuthorization } from '#/reduxState/delegatedKey/authorizationReducer';
import { displayGlobalError } from '#/reduxState/exchange/errorModalReducer';
import { staticDispatch } from '#/reduxState/store';
import { IWallet } from '#/reduxState/wallet/walletReducer';

/** Note that TPSL Conditional orders are canceled using cancelConditionalTPSLOrderWithSignModal */
export const cancelOrderWithSignModal = (
  orderId: string,
  wallet: IWallet,
  delegatedWallet?: DelegatedKeyAuthorization
): Promise<unknown> => {
  return cancelOrder(
    orderId,
    wallet.walletAddress,
    (...typedData) =>
      signTypedDataWithModal(
        wallet,
        delegatedWallet,
        typedData,
        'Please sign the transaction to cancel your order.'
      ),
    delegatedWallet
  );
};

export const prepareCancelErrorMessage = (error: Error) => {
  const errorMessage =
    makeEthersErrorHumanRedable(error) ||
    'Error occured while trying to cancel your order';
  return errorMessage;
};

export const displayCancelErrorModal = (error: Error) => {
  console.warn(error);
  const errorMessage = prepareCancelErrorMessage(error);
  staticDispatch(displayGlobalError(errorMessage));
};

export const cancelAllOrdersWithSignModal = (
  marketFilter: string | false,
  wallet: IWallet,
  delegatedWallet?: DelegatedKeyAuthorization
): Promise<unknown> => {
  return cancelAllOrders(
    marketFilter,
    wallet.walletAddress,
    (...typedData) =>
      signTypedDataWithModal(
        wallet,
        delegatedWallet,
        typedData,
        'Please sign the transaction to cancel your order.'
      ),
    delegatedWallet
  );
};
